module.exports = __webpack_public_path__ + "img/order-return-reason.a0e77b29.svg";